import React, { useRef, useEffect, useState } from 'react';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';
import Fab from '@mui/material/Fab';
import ReplyIcon from '@mui/icons-material/Reply';
import { useLocation, useNavigate } from 'react-router-dom';
import { mailDetail } from './api';

// 定义自定义 VideoBlot
const BlockEmbed = Quill.import('blots/block/embed');
class VideoBlot extends BlockEmbed {
    static create(value) {
        let node = super.create();
        node.setAttribute('controls', '');
        node.setAttribute('width', '100%');
        node.setAttribute('src', value);
        return node;
    }

    static value(node) {
        return node.getAttribute('src');
    }
}
VideoBlot.blotName = 'video';
VideoBlot.tagName = 'video';

// 注册 VideoBlot
Quill.register(VideoBlot);

function MailDetail() {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = location.state || {};
    const editorRef = useRef(null);
    const [content, setContent] = useState({});

    useEffect(() => {
        if (!id) return;

        // 初始化 Quill 实例
        const quillInstance = new Quill(editorRef.current, {
            theme: 'snow',
            modules: {
                toolbar: false,
            },
            readOnly: true,
        });

        // 加载邮件详情并插入内容
        getDetail(quillInstance);

        return () => {
            if (quillInstance) {
                quillInstance.disable();
            }
        };
    }, [id]);

    const getDetail = async (quillInstance) => {
        try {
            const result = await mailDetail({ id });
            setContent(result);
            setTimeout(() => {
                if (quillInstance) {
                    // 先插入文本内容
                    quillInstance.clipboard.dangerouslyPasteHTML(result.content || '');
                }
            }, 0);

        } catch (error) {
            console.error("Error fetching mail detail:", error);
        }
    };

    const handleReply = () => {
        // 假设路径为 '/richTextEditor'，通过 state 传递原文内容
        navigate('/richTextEditor', {
            state: {
                originalContent: content.content, // 直接传递 content 的 HTML
                userId: content.receivedUser,
                receivedUserId: content.sendUser,
                originalTitle: content.title
            }
        });
    };

    return (
        <Paper square sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column', padding: 2 }}>
            <TextField
                label="标题"
                variant="outlined"
                value={content.title || ''}
                sx={{ marginBottom: 2 }}
                disabled={true}
            />
            <div ref={editorRef} style={{ flex: 1, minHeight: '200px' }} />
            {/* 添加回复按钮 */}
            <Fab
                color="primary"
                aria-label="reply"
                onClick={handleReply}
                sx={{
                    position: 'fixed',
                    bottom: 30,
                    right: 45,
                }}
            >
                <ReplyIcon />
            </Fab>
        </Paper>
    );
}

export default MailDetail;